import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["button"];
  static values = { defaultLabel: String, newOne: String, newOther: String };

  connect() {
    this._newCount = 0;
    this.scrollContainer = this.element.closest(
      ".single-post-page__scroll-container"
    );
    this.commentsContainer = this.scrollContainer?.querySelector(
      ".single-post-page__comments"
    );

    if (!this.commentsContainer) return;

    // Determine the actual scrolling ancestor:
    // Mobile: scroll-container has overflow-y: auto (internal scrolling)
    // Desktop: overflow: visible, so the page scrolls (use viewport)
    const style = getComputedStyle(this.scrollContainer);
    const isScrollable =
      style.overflowY === "auto" || style.overflowY === "scroll";
    const root = isScrollable ? this.scrollContainer : null;

    this.intersectionObserver = new IntersectionObserver(
      ([entry]) => {
        this._atBottom = entry.isIntersecting;
        this.buttonTarget.hidden = entry.isIntersecting;
        if (entry.isIntersecting) {
          this.#reset();
        }
      },
      { root, threshold: 0.1 }
    );

    // Watch for new comments added via Turbo Stream
    this.mutationObserver = new MutationObserver(() => {
      this.observeLastComment();
    });
    this.mutationObserver.observe(this.commentsContainer, { childList: true });

    this.observeLastComment();
  }

  disconnect() {
    this.intersectionObserver?.disconnect();
    this.mutationObserver?.disconnect();
  }

  observeLastComment() {
    this.intersectionObserver.disconnect();

    const lastChild = this.commentsContainer.lastElementChild;

    if (lastChild) {
      this.intersectionObserver.observe(lastChild);
    } else {
      this.buttonTarget.hidden = true;
    }
  }

  buttonTargetConnected(button) {
    if (this._atBottom) {
      this.#reset();
      button.hidden = true;
    } else if (button.classList.contains("new")) {
      this._newCount = (this._newCount || 0) + 1;
      const label =
        this._newCount === 1
          ? this.newOneValue
          : this.newOtherValue.replace("%{count}", this._newCount);
      button.querySelector("span").textContent = label;
    }
  }

  scroll() {
    const lastChild = this.commentsContainer.lastElementChild;

    if (lastChild) {
      lastChild.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  #reset() {
    this._newCount = 0;
    this.buttonTarget.classList.remove("new");
    this.buttonTarget.querySelector("span").textContent = this.defaultLabelValue;
  }
}
